import {useTranslation} from "react-i18next";
import {makeStyles} from "@material-ui/core/styles";
import {AuthContext, ThemeContext} from "../../contexts";
import i18next from "../../i18n/i18next";

const DigitalLink =  () => {
    return (<div>Digital Link by Wiseside</div>)
}

export default DigitalLink